import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { MaterialIcon } from "../../../utils";
import Fab from "@material-ui/core/Fab";

const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
        color: theme.palette.common.black
    },
    tooltip: {
        backgroundColor: theme.palette.common.black,
        fontSize: "13px"
    }
}));

const CustomTooltip = (props) => {
    const classes = useStylesBootstrap();
    return <Tooltip arrow classes={classes} {...props} />;
};

const MRoundButton = ({ color, onClick, title, icon, size, ...props }) => {
    return (
        <Fragment>
            <CustomTooltip title={title}>
                <Fab
                    color={color}
                    aria-label={title}
                    style={{ outline: "none" }}
                    size={size}
                    onClick={onClick}
                    {...props}
                >
                    {icon}
                </Fab>
            </CustomTooltip>
        </Fragment>
    );
};

MRoundButton.defaultProps = {
    icon: <MaterialIcon.AddIcon />,
    onClick: null,
    size: "small",
    title: "",
    color: "primary"
};

export default MRoundButton;
